module.exports = __webpack_public_path__ + "static/img/3_10_1.5ef24907.jpg";